import React from "react";
import ons from "onsenui";
import { Button, ToolbarButton, Icon } from "react-onsenui";

export default class ShareUrlButton extends React.Component {
  state = {
    copiedToClipboard: false,
  };

  copyToClipboard() {
    navigator.clipboard.writeText(window.location.href);
    ons.notification.toast('Page URL copied to clipboard', { timeout: 2000, animation: 'fall' });
  }

  render() {
    const size = this.props['size'] || 16;
    return <ToolbarButton onClick={this.copyToClipboard.bind(this)}>
        <Icon icon="fa-link" size={size} />
        {this.props.withButtonText ? <span style={{paddingLeft: '5px'}}></span> : ''}
      </ToolbarButton>;
  }
}
